<template>
  <h2
    v-if="accountStatus"
    class="text-sm m-0 px-2 rounded-full text-white"
    :class="isActive ? 'bg-green' : 'bg-red'"
  >
    <span v-text="'Account Status: '" />
    <span v-text="accountStatus" />
  </h2>
</template>

<script type="text/babel">
import { mapState } from 'vuex'

export default {
  name: 'AccountStatusBanner',
  props: {
    setupMode: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapState({
      stripeAccount: state => state.payments.stripeAccount,
    }),
    accountStatus() {
      return this.setupMode
        ? 'Setup Mode'
        : this.stripeAccount.hasOwnProperty('id') ? _.capitalize(this.stripeAccount.capabilities.transfers) : ''
    },
    isActive() {
      return this.accountStatus === 'Active'
    },
  },
}
</script>